import React from "react";

import DataTable from "../../../DataTable";

import useOutputReportStore from "../../../../store/OutputReport.store";
import {
  extractRowKeys,
  formatDataTableColumns,
  getOutputType,
} from "../../../../utils/helpers/dataTable";
import { dataTableCopy } from "../../../../utils/resources/dataTableCopy";
import { definitions } from "../../../../utils/resources/definitionsCopy";
import Definitions from "../../../Definitions";

const getFootnote = ({ reportType }) => {
  if (reportType === "cash") {
    return (
      <>
        {dataTableCopy.unlessOtherwiseStated}
        <br />
        [1]{dataTableCopy.activeRiskExposure}
        <br />
        [2]{dataTableCopy.targetPortfolios}
        <br />
        [3]{dataTableCopy.seeBenchmark}
      </>
    );
  }

  return (
    <>
      {dataTableCopy.unlessOtherwiseStated}
      <br />
      [1]{dataTableCopy.activeRiskExposure}
      <br />
      [2]{dataTableCopy.existingPortfolioInformation}
      <br />
      [3]{dataTableCopy.transitionAnalysisDiscussed}
      <br />
      [4]{dataTableCopy.seeBenchmark}
    </>
  );
};

const SectorsDataTable = () => {
  const reportName = "Style (Risk Exposure)"; // Refer to corresponding API Key
  const data = useOutputReportStore((state) => state.data);
  const types = useOutputReportStore((state) => state.types);
  const { reportType } = getOutputType(data);

  const dataTableColumns = formatDataTableColumns(reportName, data);

  const rowKeys = extractRowKeys(reportName, data).filter(
    (row) => !row?.label.includes("Total")
  );

  const definitionsHeading = "Style Risk Exposures Definitions";
  const definitionsArgs = {
    isHeadingHidden: true,
    bodyContent: [
      {
        listContent: [
          {
            heading: definitionsHeading,
            content: [
              definitions.usBeta,
              definitions.usDividendYield,
              definitions.usEarningsQuality,
              definitions.usEarningYield,
              definitions.usEarningsVariability,
              definitions.usGrowth,
              definitions.usLiquidity,
              definitions.usLeverage,
              definitions.usLongTermReversal,
              definitions.usManagementQuality,
              definitions.usMidCapitalization,
              definitions.usMomentum,
              definitions.usProfitabitlity,
              definitions.usProspect,
              definitions.usResidualVolatility,
              definitions.usSize,
              definitions.usValue,
            ],
          },
        ],
      },
    ],
    isReportPage: false,
  };

  const getDefinitions = () => <Definitions {...definitionsArgs} />;

  return (
    <DataTable
      reportType={reportType}
      variation="stylized"
      tableCaption={`${reportName} Data Table`}
      tableRowHeaderKey="Style Risks"
      tableRowKeys={rowKeys}
      tableColumns={dataTableColumns}
      tableDataTypes={types?.[reportName]}
      formatCellDataBy="row"
      footnote={getFootnote({ reportType })}
      definitions={getDefinitions()}
      hasProfitLabel={true}
      name={"Style (Risk Exposure)"}
    />
  );
};

export default SectorsDataTable;
